import { useEffect, useRef, useState } from 'react';
import { loadModules } from 'esri-loader';

const MeasureWidget = ({ view }) => {
    const containerRef = useRef(null);
    const distanceBtnRef = useRef(null);
    const areaBtnRef = useRef(null);
    const [measurementWidget, setMeasurementWidget] = useState(null);
    const [activeTool, setActiveTool] = useState(null); // 'distance' | 'area' | null

    useEffect(() => {
        if (!view || !view.ui) return;

        loadModules(['esri/widgets/Measurement']).then(([Measurement]) => {
            const widget = new Measurement({
                view,
                container: containerRef.current,
                activeTool: null
            });
            setMeasurementWidget(widget);

            const toggleTool = (tool) => {
                if (widget.activeTool === tool) {
                    widget.activeTool = null;
                    setActiveTool(null);
                } else {
                    widget.activeTool = tool;
                    setActiveTool(tool);
                }
            };

            const createButton = (iconClass, title, toolType, ref) => {
                const btn = document.createElement('div');
                btn.className = `esri-widget esri-widget--button ${iconClass}`;
                btn.title = title;
                btn.style.cursor = 'pointer';
                btn.style.padding = '12px';
                btn.onclick = () => toggleTool(toolType);
                ref.current = btn;
                return btn;
            };

            const distanceBtn = createButton('esri-icon-measure', 'Measure Distance', 'distance', distanceBtnRef);
            const areaBtn = createButton('esri-icon-polygon', 'Measure Area', 'area', areaBtnRef);

            view.ui.add([distanceBtn, areaBtn], 'top-left');
        });

        return () => {
            if (distanceBtnRef.current) view.ui.remove(distanceBtnRef.current);
            if (areaBtnRef.current) view.ui.remove(areaBtnRef.current);
            if (measurementWidget) measurementWidget.destroy();
        };
    }, [view]);

    useEffect(() => {
        const show = activeTool === 'distance' || activeTool === 'area';
        if (containerRef.current) {
            containerRef.current.style.display = show ? 'block' : 'none';
        }

        if (distanceBtnRef.current) {
            distanceBtnRef.current.style.backgroundColor = activeTool === 'distance' ? '#ffffff92' : '#fff';
        }

        if (areaBtnRef.current) {
            areaBtnRef.current.style.backgroundColor = activeTool === 'area' ? '#ffffff92' : '#fff';
        }
    }, [activeTool]);


    return (
        <div
            ref={containerRef}
            style={{
                display: 'none',
                resize: 'both',
                overflow: 'auto',
                minWidth: '400px',
                minHeight: '200px',
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                padding: '10px',
                position: 'absolute',
                top: '15px',
                left: '60px',
                zIndex: 10
            }}
        />
    );
};

export default MeasureWidget;
